export default __webpack_public_path__ + "static/media/pvn-arte-10.b018fae0.webp";